import { isString } from 'util'

const toast = ($mdToast, $mdDialog) => {
  'ngInject'

  const showSuccess = (message) => {
    $mdToast.show({
      template: '<md-toast class="md-toast-success">' + message + '</md-toast>',
      hideDelay: 5000
    })
  }

  const showWarning = (message) => {
    const toast = $mdToast.simple()
        .textContent(message)
        .toastClass('md-toast-warning')
        .action('DISMISS')
        .highlightAction(true)
        .highlightClass('md-accent')
        .hideDelay(false)

    $mdToast.show(toast)
  }

  const showError = (error, message = '') => {
    const reason = error !== null && typeof error.data !== 'undefined' && typeof error.data.reason !== 'undefined' ? error.data.reason : ''

    if (reason) {
      if (message) {
        message += ` (${reason})`
      } else {
        message = reason
      }
    }

    if (!message) {
      message = 'Oops... Something went wrong!'
    }

    const toast = $mdToast.simple()
      .textContent(message)
      .toastClass('md-toast-warning')
      .action('DISMISS')
      .highlightAction(true)
      .highlightClass('md-accent')
      .hideDelay(false)
    $mdToast.show(toast)
  }

  const showLoader = () => {
    $mdDialog.show({
      template: `
      <md-dialog style="background-color:transparent;box-shadow:none; overflow: hidden;" layout-align="center center">
        <div class="loader-background" layout="column" layout-align="center center">
          <img class="loader-logo" src="images/bluecrew-logo.svg"/>
          <md-progress-linear md-mode="indeterminate" style="max-width:130px">
          </md-progress-linear>
        </div>
      </md-dialog>`,
      parent: document.body
    })
  }

  const hideLoader = () => {
    $mdDialog.hide()
  }

  return {
    showSuccess,
    showWarning,
    showError,
    showLoader,
    hideLoader
  }
}

export default toast
